import * as React from 'react';
import { Scroller, Slider, Image, Buttons } from '@cian/slider';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var Carousel = function Carousel(_ref) {
  var media = _ref.media,
    loop = _ref.loop,
    onSlideChange = _ref.onSlideChange;
  return /*#__PURE__*/_jsxs(Slider, {
    onSlideChange: onSlideChange,
    loop: loop,
    children: [/*#__PURE__*/_jsx(Scroller, {
      children: media.map(function (m, index) {
        return /*#__PURE__*/_jsx(Image, {
          src: m.url,
          objectFit: "cover",
          loading: index === 0 ? null : undefined,
          decoding: index === 0 ? null : undefined
        }, "slide_".concat(index));
      })
    }), media.length > 1 && /*#__PURE__*/_jsx(Buttons, {
      size: "S"
    })]
  });
};